import { Link as RouterLink } from 'react-router-dom';
import MainImageCardDashboard3 from "../../../components/Cards/MainImageCardDashboard3";
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { clock } from "../../../constants";


export default function BioCard() {

return (
<>

    <MainImageCardDashboard3

        content = {<>
                    <HeaderCardSmall cardheadline={'Epigenetic Clock'} />
                   
                </>}

       iconbuttons = {<>               

                        <Tooltip title="Epigenetic Clock" placement="bottom">
                                <IconButton component={RouterLink} to="/ClockWelcome" size="large">
                                        <ManageHistoryIcon sx={{color: 'common.white', '&:hover': { color: 'common.white'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  
       

        photo = { clock }  

    />

</>
)};
